{
  "ProductionTemplateCreateModal": {
    "includeBudgeting": "Include budgeting",
    "customise": "Customise",
    "newTemplate": "New production template",
    "description": "Create and edit production templates for your company",
    "saveChanges": "Save changes",
    "updateFailed": "Update Failed",
    "defaultIcon": "Default icon",
    "defaultColor": "Default color",
    "defaultCode": "Default code",
    "defaultTitle": "Default title",
    "defaultNumberOfDays": "Default number of days",
    "defaultTags": "Default tags",
    "shotflowInstance": "Shotflow instance",
    "noInstance": "No Instance Selected",
    "requiredField": "This is required",
    "workspaceSetup": "Workspace setup",
    "callsheets": "Callsheets",
    "deleteTemplate": "Delete Template",
    "deleteConfirmationTitle": "Are you sure you want to delete this production template?",
    "deleteConfirmationButton": "Delete template",
    "newBudgetGroup": "New budget group",
    "newBudgetExpense": "New budget expense",
    "createTemplate": "Create Production Template",
    "editTemplate": "Edit Production Template",
    "templateName": "Template name",
    "namePlaceholder": "Name",
    "fieldRequired": "This field is required",
    "cancel": "Cancel",
    "updatedSuccessfully": "Updated successfully",
    "locations": "Locations",
    "crew": "Crew",
    "stages": {
      "templateDetails": {
        "title": "Template Details",
        "desc": "Set a description for your template"
      },
      "productionDefaults": {
        "title": "Production defaults",
        "desc": "Set your data defaults to be auto-populated into various fields when creating the production"
      },
      "resourceDefaults": {
        "title": "Resource defaults",
        "desc": "Set your resource defaults for this template allowing users to have a starting point of what resources are required for this production."
      }
    }
  },
  "resourcingViewModeTablistLabel": "Planned, actual, and budget",
  "resourcingPageTitlePlanned": "Planned",
  "resourcingPageTitleActuals": "Actuals",
  "productionListViewOptions": "View options",
  "productionListShowResourcingBudgetColumn": "Budgeting",
  "productionListBudgetChartModeLabel": "Budget chart",
  "productionListBudgetChartVsPlanned": "Reconciled vs planned",
  "productionListBudgetChartVsBudget": "Planned & reconciled vs budget",
  "productionListCrewColumnLabel": "CREW",
  "productionListCrewBookedShort": "Booked",
  "productionListCrewCellAria": "{{booked}} of {{total}} roles booked",
  "productionListCrewPercentTitle": "{{percent}}% of roles booked",
  "productionListCrewCompleteTitle": "All roles booked",
  "productionListCrewNoRoles": "No roles",
  "productionListBudgetColumnLabel": "BUDGETING",
  "productionListBudgetPlannedShort": "Plan",
  "productionListBudgetActualShort": "Actual",
  "productionListBudgetCellAria": "Budget {{target}}, planned {{planned}}, reconciled {{reconciled}}",
  "productionListBudgetCellAriaNoReconciled": "Budget {{target}}, planned {{planned}}, no reconciled total yet",
  "productionListBudgetCellAriaVsPlanned": "Planned {{planned}}, reconciled {{reconciled}}",
  "productionListBudgetCellAriaVsPlannedNoReconciled": "Planned {{planned}}, no reconciled total yet",
  "productionListBudgetCellAriaPlannedOnly": "Planned {{planned}}, no actual total yet",
  "productionListBudgetNoReconciled": "no reconciled",
  "productionListBudgetNoActual": "no actual",
  "productionListBudgetTargetMarkerTitle": "100% of production budget",
  "productionListBudgetPlanMarkerTitle": "100% of planned amount",
  "productionDetailNotesTitle": "Notes",
  "productionDetailFilesTitle": "Files",
  "resourcingFooterBookedBadgeAria": "Roles filled: {{booked}} of {{total}}",
  "resourcingFooterTotalPlanned": "Total planned {{amount}}",
  "resourcingFooterTotalActual": "Total actual {{amount}}",
  "resourcingViewLoadingAria": "Loading resourcing",
  "resourcingDragOverlayAria": "Dragging resourcing item",
  "resourcingDragOverlayKindGroup": "Group",
  "resourcingDragOverlayKindRole": "Role",
  "resourcingDragOverlayKindExpense": "Expense",
  "resourcingDragOverlayKindResourceLine": "Assignment",
  "resourcingDragOverlayKindExpenseLine": "Expense line",
  "resourcingSlotCategoryPlaceholder": "Select category",
  "resourcingSlotExpensePlaceholder": "Select expense",
  "resourcingGridColumnGroupName": "Group",
  "resourcingGridColumnItemName": "Item",
  "resourcingGridColumnOrderAria": "Slot number",
  "resourcingGridColumnRate": "Rate",
  "resourcingGridColumnQtyUnit": "Qty / Unit",
  "resourcingGridColumnSubtotal": "Subtotal",
  "resourcingGridColumnFees": "Fees",
  "resourcingGridColumnExpenses": "Expenses",
  "resourcingGridColumnTotal": "Total",
  "resourcingItemAddResource": "Add a resource",
  "resourcingItemAddExpense": "Add an expense",
  "resourcingExpenseLineEditTitle": "Edit expense",
  "resourcingExpenseLineCreateTitle": "Add expense",
  "resourcingExpenseLineEditCategory": "Expense Category",
  "resourcingExpenseLineEditName": "Expense Name",
  "resourcingExpenseLineEditCancel": "Cancel",
  "resourcingExpenseLineEditSave": "Save changes",
  "resourcingExpenseLineCreateSave": "Add expense",
  "resourcingExpenseLineEditClose": "Close",
  "resourcingItemBookingDetails": "Details",
  "resourcingItemResourceLoadError": "Could not load resource",
  "resourcingAssignDialogSearchResources": "Search resources",
  "resourcingAssignDialogSelectResources": "Select resource(s)",
  "resourcingAssignDialogSelectedCount_one": "{{count}} selected",
  "resourcingAssignDialogSelectedCount_other": "{{count}} selected",
  "resourcingAssignDialogUnselectAll": "Unselect all",
  "resourcingAssignDialogNoResourcesFound": "No resources found",
  "resourcingAssignDialogLoadFailed": "Failed to load resources",
  "resourcingAssignDialogDefaultRateLabel": "Default rate: {{rate}}",
  "resourcingAssignDialogNoRole": "No role",
  "resourcingAssignDialogNoDefaultRate": "No rate",
  "resourcingAssignDialogConflictCount_one": "{{count}} conflict",
  "resourcingAssignDialogConflictCount_other": "{{count}} conflicts",
  "resourcingAssignDialogApplyPlannedEstimate": "Apply planned estimate to assigned resources",
  "resourcingAssignDialogPlannedEstimate": "Planned estimate",
  "resourcingAssignDialogAppliedToCount_one": "Applied to {{count}} resource",
  "resourcingAssignDialogAppliedToCount_other": "Applied to {{count}} resources",
  "resourcingAssignDialogAssignedBookingsToBeCreated": "Assigned booking to be created",
  "resourcingAssignDialogNext": "Next",
  "resourcingAssignDialogBack": "Back",
  "resourcingAssignDialogAssignResource": "Assign resource",
  "resourcingDetailsOpenBookingAria": "Open booking",
  "resourcingDocsOpenBookingInvoicesAria": "Open booking invoices and receipts",
  "resourcingDocsOpenExpenseReceiptsAria": "Open expense receipts",
  "resourcingDocsAddLabel": "Add",
  "resourcingGridColumnPlannedTotal": "Planned Total",
  "resourcingGridColumnInvoicesReceipts": "Invoices / Receipts",
  "resourcingGridColumnActualsTotal": "Actuals Total",
  "resourcingGridColumnVariance": "Variance",
  "resourcingPendingExpenseLineAria": "Creating expense line",
  "resourcingAddExpensePickCategoryFirst": "Choose an expense category on this row (or add expense categories in settings) before adding a line.",
  "resourcingCreateExpenseFailed": "Could not add expense line",
  "resourcingNewExpenseVendorPlaceholder": "New expense",
  "resourcingRowActionsColumnLabel": "Actions",
  "resourcingRowActionsMenuLabel": "Open row actions",
  "resourcingRowActionsDeleteRole": "Delete role",
  "resourcingRowActionsDeleteExpenseSlot": "Delete expense",
  "resourcingRowActionsRemoveAssignment": "Remove resource",
  "resourcingRowActionsDeleteExpenseLine": "Delete expense line",
  "resourcingRowActionsDuplicateRole": "Duplicate role",
  "resourcingRowActionsDuplicateExpenseSlot": "Duplicate expense slot",
  "resourcingRowActionsExcludeCostsFromBudget": "Exclude costs from budget",
  "resourcingRowActionsIncludeCostsInBudget": "Include costs in budget",
  "resourcingSlotContextMenuAddResource": "Add resource",
  "resourcingSlotContextMenuAddExpense": "Add expense",
  "resourcingRowContextSendBooking": "Send booking update",
  "resourcingPageActionsMenuLabel": "Actions",
  "resourcingPageActionsSendBookingUpdates": "Send booking updates",
  "resourcingPageActionsSendBookingUpdatesNoPermission": "You don't have permission to send booking updates. Contact your administrator if you need access.",
  "resourcingPageActionsBatchAddToShortlist": "Batch add to shortlist",
  "sendBookingConfirmationDialog": {
    "title": "Send booking update",
    "titleBulk": "Send booking updates",
    "description": "Review which confirmation template will be used, then send the email.",
    "descriptionBulk": "Review which confirmation template will be used, then send updates to every eligible booking on this production.",
    "scopeOrganizationTitle": "Organization (global) template",
    "scopeOrganizationDescription": "This email uses the organization (global) confirmation template.",
    "scopeWorkspaceTitle": "Workspace template · {{workspace}}",
    "scopeWorkspaceFallback": "Workspace",
    "scopeWorkspaceDescription": "This email uses this workspace’s confirmation template.",
    "scopeWorkspaceFallbackToGlobal": "This workspace has no override. The organization (global) template will be used.",
    "editTemplateLink": "Edit confirmation template",
    "recipientLabel": "Recipient",
    "recipientValue": "{{name}} · {{email}}",
    "recipientsBulkCount_one": "{{count}} recipient",
    "recipientsBulkCount_other": "{{count}} recipients",
    "recipientsBulkEmpty": "No confirmed bookings waiting for a confirmation on this production.",
    "recipientsBulkNoneReady": "No recipients can be emailed yet. Add email addresses for the contacts listed above.",
    "recipientsMissingEmailMessage": "No email found for these resources. They will be skipped.",
    "recipientProblemMissingEmail": "No email",
    "recipientsLoadFailed": "Couldn’t load recipients for this production.",
    "previewPrevious": "Previous recipient preview",
    "previewNext": "Next recipient preview",
    "previewPosition": "{{current}} / {{total}}",
    "unknownRecipient": "Resource",
    "noEmailInline": "This resource has no email address. Add an email before sending.",
    "templatePreviewLabel": "Email preview",
    "templatePreviewHint": "This is the content that will be sent to the contact",
    "templateEmpty": "No confirmation template is configured for this scope.",
    "templateLoadFailed": "Couldn’t load the confirmation template.",
    "cancel": "Cancel",
    "send": "Send",
    "sendSuccess": "Booking confirmation sent",
    "sendSuccessBulk": "Booking updates sent",
    "sendFailed": "Failed to send booking update",
    "missingTemplateDescription": "You cannot send a booking confirmation without a booking confirmation template. Please add a confirmation template to continue.",
    "goToTemplates": "Go to confirmation template"
  },
  "resourcingContextMenuSectionRow": "This row",
  "resourcingContextMenuSubmenuSlot": "Slot · {{name}}",
  "resourcingContextMenuSubmenuSlotUnnamed": "Slot",
  "resourcingContextMenuOtherLevels": "Other levels",
  "resourcingContextMenuSubgroup": "Group · {{name}}",
  "resourcingGroupContextMenuAddRole": "Add role",
  "resourcingGroupContextMenuAddExpense": "Add expense",
  "resourcingGroupContextMenuDuplicate": "Duplicate group",
  "resourcingGroupContextMenuDelete": "Delete group",
  "resourcingGroupBookedAvailableCounter": "{{booked}}/{{available}}",
  "resourcingGroupNamePlaceholder": "Unnamed group",
  "resourcingAddGroup": "Add group",
  "resourcingSyncAllSaved": "Saved",
  "resourcingSyncSavingWithCount": "Saving ({{count}})",
  "resourcingSyncSomeFailed": "Save failed",
  "resourcingSyncActivityHeading": "Sync activity",
  "resourcingSyncActivityAutoScroll": "Auto-scroll",
  "resourcingSyncActivityToggleAria": "Show or hide sync activity details",
  "resourcingSyncPauseOnline": "Pause online sync",
  "resourcingSyncResumeOnline": "Resume online sync",
  "resourcingSyncPaused": "Online sync paused",
  "resourcingSyncPausedWithCount": "{{count}} waiting to sync",
  "resourcingSyncActivityStatus_executing": "Syncing",
  "resourcingSyncActivityStatus_queued": "Queued",
  "resourcingSyncActivityStatus_staged": "Pending",
  "resourcingSyncActivityStatus_awaiting_resume": "Waiting for resume",
  "resourcingSyncActivityStatus_success": "Saved",
  "resourcingSyncActivityStatus_error": "Failed",
  "resourcingAction.default": "Change saved",
  "resourcingAction.default_pending": "Save change",
  "resourcingAction.updateSlotNote": "Note updated",
  "resourcingAction.updateSlotNote_pending": "Update note",
  "resourcingAction.updateSlotIncludeInCalculationIncluded": "Included in calculation",
  "resourcingAction.updateSlotIncludeInCalculationIncluded_pending": "Include in calculation",
  "resourcingAction.updateSlotIncludeInCalculationExcluded": "Excluded from calculation",
  "resourcingAction.updateSlotIncludeInCalculationExcluded_pending": "Exclude from calculation",
  "resourcingAction.updateSlotCategory": "Category updated",
  "resourcingAction.updateSlotCategory_pending": "Update category",
  "resourcingAction.reorderSlots": "Slots reordered",
  "resourcingAction.reorderSlots_pending": "Reorder slots",
  "resourcingAction.reorderGroups": "Groups reordered",
  "resourcingAction.reorderGroups_pending": "Reorder groups",
  "resourcingAction.createResourceSlot": "Role added",
  "resourcingAction.createResourceSlot_pending": "Add role",
  "resourcingAction.duplicateResourceSlot": "Role duplicated",
  "resourcingAction.duplicateResourceSlot_pending": "Duplicate role",
  "resourcingAction.duplicateBudgetExpense": "Expense slot duplicated",
  "resourcingAction.duplicateBudgetExpense_pending": "Duplicate expense slot",
  "resourcingAction.addBudgetExpense": "Expense added",
  "resourcingAction.addBudgetExpense_pending": "Add expense",
  "resourcingAction.createResourceAssignments": "Resource assigned",
  "resourcingAction.createResourceAssignments_pending": "Assign resource",
  "resourcingAction.createBudgetExpenseLine": "Expense line added",
  "resourcingAction.createBudgetExpenseLine_pending": "Add expense line",
  "resourcingAction.deleteResourceSlot": "Role deleted",
  "resourcingAction.deleteResourceSlot_pending": "Delete role",
  "resourcingAction.deleteBudgetExpense": "Expense deleted",
  "resourcingAction.deleteBudgetExpense_pending": "Delete expense",
  "resourcingAction.deleteExpenseLine": "Expense line deleted",
  "resourcingAction.deleteExpenseLine_pending": "Delete expense line",
  "resourcingAction.deleteResourceSlotAssignment": "Assignment removed",
  "resourcingAction.deleteResourceSlotAssignment_pending": "Remove assignment",
  "resourcingAction.createProductionGroup": "Group created",
  "resourcingAction.createProductionGroup_pending": "Create group",
  "resourcingAction.duplicateProductionGroup": "Group duplicated",
  "resourcingAction.duplicateProductionGroup_pending": "Duplicate group",
  "resourcingAction.updateProductionGroup": "Group renamed",
  "resourcingAction.updateProductionGroup_pending": "Rename group",
  "resourcingAction.deleteProductionGroup": "Group deleted",
  "resourcingAction.deleteProductionGroup_pending": "Delete group",
  "resourcingAction.updateResourceSlotPlanRates": "Role plan rate and fees updated",
  "resourcingAction.updateResourceSlotPlanRates_pending": "Update role plan rate and fees",
  "resourcingAction.updateAssignedResourceLineInterval": "Booking interval updated",
  "resourcingAction.updateAssignedResourceLineInterval_pending": "Update booking interval",
  "resourcingAction.updateResourceLineQtyUnit": "Quantity and unit updated",
  "resourcingAction.updateResourceLineQtyUnit_pending": "Update quantity and unit",
  "resourcingAction.updateResourceLineFees": "Fees updated",
  "resourcingAction.updateResourceLineFees_pending": "Update fees",
  "resourcingAction.updateBookingRate": "Booking rate updated",
  "resourcingAction.updateBookingRate_pending": "Update booking rate",
  "resourcingAction.updateBookingFees": "Booking fees updated",
  "resourcingAction.updateBookingFees_pending": "Update booking fees",
  "resourcingAction.updateBookingRatesAndFees": "Booking rate and fees updated",
  "resourcingAction.updateBookingRatesAndFees_pending": "Update booking rate and fees",
  "resourcingAction.updateBookingExpenseLines": "Booking expenses updated",
  "resourcingAction.updateBookingExpenseLines_pending": "Update booking expenses",
  "resourcingAction.updateBookingStatus": "Booking status updated",
  "resourcingAction.updateBookingStatus_pending": "Update booking status",
  "resourcingAction.updateBudgetExpensePlanRateFields": "Expense plan rate updated",
  "resourcingAction.updateBudgetExpensePlanRateFields_pending": "Update expense plan rate",
  "resourcingAction.updateBudgetExpensePlanQuantity": "Expense plan quantity updated",
  "resourcingAction.updateBudgetExpensePlanQuantity_pending": "Update expense plan quantity",
  "resourcingAction.updateBudgetExpensePlanRates": "Expense plan updated",
  "resourcingAction.updateBudgetExpensePlanRates_pending": "Update expense plan",
  "resourcingAction.updateExpenseLineCommittedRateFields": "Expense line rate updated",
  "resourcingAction.updateExpenseLineCommittedRateFields_pending": "Update expense line rate",
  "resourcingAction.updateExpenseLineCommittedQuantity": "Expense line quantity updated",
  "resourcingAction.updateExpenseLineCommittedQuantity_pending": "Update expense line quantity",
  "resourcingAction.updateExpenseLineCommittedRates": "Expense line updated",
  "resourcingAction.updateExpenseLineCommittedRates_pending": "Update expense line",
  "resourcingLeaveWhileSavingTitle": "Changes still saving",
  "resourcingLeaveWhileSavingDescription": "Some changes are still being saved to the server. If you leave now, saving will continue in the background.",
  "resourcingLeaveWhileSavingConfirm": "Leave anyway",
  "resourcingLeaveWhileSavingCancel": "Keep editing",
  "resourcingLeaveWhileSavingBeforeUnload": "Changes are still saving. Are you sure you want to leave?",
  "resourcingRatesInlineTitleBooking": "Booking costs",
  "resourcingRatesInlineTitleExpense": "Expense costs",
  "resourcingRatesInlineTitleExpensePlan": "Expense plan",
  "resourcingRatesInlineExpensePlanHint": "Budget this slot here. Edit committed amounts on each expense line below.",
  "resourcingCostSheetLaneExpensePlan": "Planned for this slot",
  "resourcingCostSheetFooterExpensePlan": "Expense plan total",
  "resourcingCostSheetExpenseCommittedIntro": "Committed rate for this line. Slot plan is on the expense row above.",
  "resourcingRatesInlineTabEstimated": "Estimated",
  "resourcingRatesInlineTabBooking": "Booking",
  "resourcingRatesInlineTabExpenseActual": "Committed",
  "resourcingRatesInlineSectionRate": "Rate",
  "resourcingRatesInlineSectionFees": "Fees",
  "resourcingRatesInlineSectionExpenses": "Expenses",
  "resourcingCostSheetSectionResourceRate": "Resource rate",
  "resourcingCostSheetSectionResourceEstimateRate": "Resource estimate rate",
  "resourcingCostSheetSectionResourceActualRate": "Actual resource rate",
  "resourcingCostSheetSectionFees": "Fees",
  "resourcingCostSheetSectionResourceExpenses": "Resource expenses",
  "resourcingRatesInlineAddExpense": "Add expense",
  "resourcingRatesInlineEmptyBooking": "Assign someone to edit.",
  "resourcingRatesInlineEmptyExpenseActual": "Set a committed rate to edit.",
  "resourcingRatesInlineTitleSlotEstimate": "Role estimate",
  "resourcingRatesInlineSlotEstimateHint": "Plan here. Book on the assignment row.",
  "resourcingCostSheetBookingIntroRowContext": "Booked costs. Role plan is above.",
  "resourcingCostSheetLanePlan": "Plan",
  "resourcingCostSheetLaneBooked": "Booked",
  "resourcingCostSheetExpenseIntro": "Estimate vs committed.",
  "resourcingCostSheetLaneEstimate": "Estimate",
  "resourcingCostSheetLaneCommitted": "Committed",
  "resourcingCostSheetFooterPlan": "Plan total",
  "resourcingCostSheetFooterBooked": "Booked total",
  "resourcingCostSheetFooterEstimate": "Estimate total",
  "resourcingCostSheetFooterCommitted": "Committed total",
  "resourcingCostSheetCalculationResourceEstimate": "Resource estimate",
  "resourcingCostSheetCalculationResourceActual": "Resource actual",
  "resourcingCostSheetCalculationExpenseEstimate": "Expense estimate",
  "resourcingCostSheetCalculationExpenseActual": "Expense actual",
  "resourcingCostSheetLaneRolePlan": "Planned for this role",
  "resourcingCostSheetFooterRolePlan": "Role plan total",
  "resourcingCostSheetRemoveExpenseAria": "Remove expense",
  "resourcingCostSheetExpenseCategory": "Category",
  "resourcingCostSheetExpenseVendor": "Name",
  "resourcingCostSheetExpenseColumnTotal": "Total",
  "resourcingSlotEstimateQuantity": "Quantity",
  "resourcingSlotEstimateFeesHeading": "Fees",
  "resourcingSlotEstimateFeeAgency": "Agency fee",
  "resourcingSlotEstimateFeePayroll": "Payroll fee",
  "resourcingSlotEstimateFeeProcessing": "Processing fee",
  "resourcingSlotEstimateFeeAgencyAria": "Include agency fee",
  "resourcingSlotEstimateFeePayrollAria": "Include payroll fee",
  "resourcingSlotEstimateFeeProcessingAria": "Include processing fee",
  "resourcingCostSheetFeeColumnAgency": "Agency fee",
  "resourcingCostSheetFeeColumnPayroll": "Payroll fee",
  "resourcingCostSheetFeeColumnProcessing": "Processing fee",
  "resourcingCostSheetFeePercentInputAgency": "Agency fee percentage",
  "resourcingCostSheetFeePercentInputPayroll": "Payroll fee percentage",
  "resourcingCostSheetFeePercentInputProcessing": "Processing fee percentage",
  "resourcingBudgetFeesPopoverRateSubtotal": "Rate subtotal",
  "resourcingBudgetFeesPopoverFeeTotal": "Fee total",
  "resourcingBudgetBookingExpensesDescriptionPlaceholder": "Description",
  "resourcingBudgetBookingExpensesCreate": "Create expense",
  "resourcingBudgetBookingExpensesIncompleteRow": "Please complete expense details before saving",
  "resourcingBudgetBookingExpensesTotal": "Expense total",
  "resourcingBookingStatusSelectAria": "Select booking status",
  "resourcingBookingStatusGroupBooking": "Booking",
  "resourcingBookingStatusGroupAvailability": "Availability",
  "productionDetailStatusSelectAria": "Select production status",
  "productionDetailStatusSearchPlaceholder": "Search statuses…",
  "productionDetailStatusGroupUser": "User actions",
  "productionDetailStatusGroupAutomated": "Automated actions",
  "productionDetailNoteCreatedToast": "Note added",
  "productionDetailNoteCreateErrorToast": "Could not add note",
  "productionDetailNoteDeletedToast": "Note removed",
  "productionDetailNoteDeleteErrorToast": "Could not remove note",
  "productionDetailNoteDeleteAria": "Remove note",
  "productionDetailNotesFieldLabel": "New note",
  "productionDetailNotesLoadError": "Could not load notes.",
  "productionDetailNotesEmptyTitle": "No notes yet",
  "productionDetailNotesEmptyDescription": "Add notes for {{name}}.",
  "productionDetailNotesEmptyFallbackName": "this production",
  "productionDetailNotesUnknownUser": "Unknown user",
  "productionDetailNotesPlaceholder": "Write a note…",
  "productionDetailNotesSubmit": "Add note",
  "productionDetailFileUploadedToast": "File uploaded",
  "productionDetailFileUploadErrorToast": "Upload failed",
  "productionDetailFileDeletedToast": "File removed",
  "productionDetailFileDeleteErrorToast": "Could not remove file",
  "productionDetailFileReorderErrorToast": "Could not save the new order",
  "productionDetailFilesLoadError": "Could not load files.",
  "productionDetailFilesEmptyTitle": "No files yet",
  "productionDetailFilesEmptyDescription": "Upload briefs, references, or contracts for {{name}}.",
  "productionDetailFilesEmptyFallbackName": "this production",
  "productionDetailFileUntitled": "Untitled file",
  "TransferProductionDialog": {
    "title": "Transfer to workspace",
    "description_one": "Move {{name}} to another workspace and team.",
    "description_other": "Move {{count}} productions to another workspace and team.",
    "fieldCurrentWorkspace": "Current workspace",
    "fieldWorkspace": "Destination workspace",
    "fieldTeam": "Destination team",
    "selectWorkspace": "Select workspace",
    "selectTeam": "Select team",
    "save": "Transfer",
    "transferFailed": "Transfer failed",
    "success_one": "Production transferred",
    "success_other": "{{count}} productions transferred"
  },
  "ProductionActions": {
    "transfer": "Transfer to workspace"
  }
}
